import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Équipe (KPI / data label) — duo de silhouettes duotone */
export const TeamIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Silhouette droite (aplat menthe) */}
      <circle cx="16.5" cy="8" r="2.5" fill="var(--equiply-icon-bg)" />
      <path
        d="M12 19.5c0-2 2-3.5 4.5-3.5s4.5 1.5 4.5 3.5"
        fill="var(--equiply-icon-bg)"
      />
      {/* Silhouette gauche (trait bleu, avec fond pour masquer) */}
      <circle cx="9" cy="9" r="3.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" fill="hsl(var(--background))" />
      <path
        d="M3 20.5c0-3 2.7-5 6-5s6 2 6 5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" fill="hsl(var(--background))"
      />
    </svg>
  ),
);
TeamIcon.displayName = "TeamIcon";
